"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _filterContainerModule = _interopRequireDefault(require("./filter-container.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FilterContainer = function FilterContainer(_ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      isMobile = _ref.isMobile,
      hasActiveFilters = _ref.hasActiveFilters,
      children = _ref.children;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showItems = _useState2[0],
      setShowItems = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex', {
      'flex-col': isMobile
    }, wrapperClassName)
  }, isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex justify-center items-center p-3 uppercase text-sm font-bold shadow-custom cursor-pointer', {
      'rounded-t': showItems,
      rounded: !showItems,
      'bg-primary text-white': hasActiveFilters
    }),
    onClick: function onClick() {
      return setShowItems(function (prev) {
        return !prev;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.responsiveFilterTitle"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterArrow, {
    className: (0, _classnames["default"])('absolute top-1/2 right-0 transform -translate-y-1/2 -translate-x-1', {
      'fill-white': hasActiveFilters,
      'fill-primary': !hasActiveFilters,
      'transform rotate-180': showItems
    })
  })), showItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute bg-white text-primary px-3 top-full w-full rounded-b z-20 shadow-custom', {
      'border-t-2 border-primary': !hasActiveFilters
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _filterContainerModule["default"].mobileContainer
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cursor-pointer flex justify-center",
    title: intl.formatMessage({
      id: 'filters.hide'
    }),
    onClick: function onClick() {
      return setShowItems(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterArrow, {
    className: "fill-primary w-8 h-8 transform rotate-180 "
  })))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_filterContainerModule["default"].itemsContainer, className)
  }, children));
};

FilterContainer.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  wrapperClassName: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool,
  hasActiveFilters: _propTypes["default"].bool
};
FilterContainer.defaultProps = {
  isMobile: false,
  hasActiveFilters: false,
  children: null,
  className: '',
  wrapperClassName: ''
};
var _default = FilterContainer;
exports["default"] = _default;